import { toast } from "react-toastify";
import { endpoints } from "../../../configs/Settings";
import { HTTPResponseStatus } from "../../../utils/enum";
import { useAuth } from "../../../utils/useAuth";
import { useAxios } from "../../../utils/useAxios";

export async function EditOrganization(
  organization: any,
  system: any,
  identifier: string
) {
  const identifierIndex = organization?.identifier?.findIndex(
    (el: any) => el.system === system
  );

  const data =
    identifierIndex === -1
      ? [
          {
            op: "add",
            path: "/identifier/-",
            value: {
              system: system,
              value: identifier,
            },
          },
        ]
      : [
          {
            op: "replace",
            path: `/identifier/${identifierIndex}/value`,
            value: identifier,
          },
        ];

  const url = `${endpoints.ADMFHIR}/Organization/${organization.id}`;
  const headers = {
    Accept: "*/*",
    Authorization: await useAuth.getUserToken(),
    "Content-Type": "application/json-patch+json",
  };

  const response = await useAxios
    .patch(url, data, { headers, timeout: 20000 })
    .then((response) => {
      if (response.status !== HTTPResponseStatus.Success) {
        throw new Error(`Edit Organization: ${response.status}`);
      }
      return { data: response.data, status: response.status };
    })
    .catch((error) => {
      console.error("EditOrganization ", error);
      // toast.error(`EditOrganization Error: ${error?.response?.status}`);
      throw new Error();
    });
  if (response) return response;
}
